/* Layout and spacing come from the @parrot/ui Table; this only adds the
   column specifics. */

.wrap {
  --metric-bar-height: 6px;
  min-width: 0;
}

/* Wide enough that metric bars have room; the Table scrolls sideways below it */
.table {
  min-width: 980px;
}

.table td {
  height: 60px;
  vertical-align: middle;
}

/* Metric columns share the width so bars line up across columns */
.table td:nth-child(n + 3) {
  min-width: 110px;
}

/* Quarter column stays put while the rest scroll sideways */
.pinned {
  position: sticky;
  left: 0;
  z-index: 1;
  background: var(--bg-card);
}

/* Header cell is sticky on both axes */
th.pinned {
  z-index: calc(var(--z-sticky) + 1);
  background: var(--bg-surface);
}

.quarter {
  font-weight: var(--weight-semi);
  white-space: nowrap;
  color: var(--text-primary);
}

.na {
  color: var(--text-disabled);
}

.loadAll {
  all: unset;
  box-sizing: border-box;
  display: block;
  width: 100%;
  padding: var(--space-3);
  border-top: 1px solid var(--border-subtle);
  text-align: center;
  font-size: var(--text-sm);
  font-weight: var(--weight-semi);
  color: var(--text-secondary);
  cursor: pointer;
  transition: background var(--duration-fast), color var(--duration-fast);
}

.loadAll:hover {
  background: var(--bg-hover);
  color: var(--text-primary);
}

.loadAll:focus-visible {
  outline: 2px solid var(--accent-secondary);
  outline-offset: -2px;
}
